// We have a transparent outline for windows
// high contrast mode, which removes decorative
// styling like box-shadow but makes borders
// and outlines 100% opacity black
const transparentOutline = 'outline: 1px solid rgba(0, 0, 0, 0);';

export const focusVisibleStylesNoWrapper = `
    box-shadow:
      0px 0px 0px 1px var(--white),
      0px 0px 0px 3px var(--purple-700);
    ${transparentOutline}
`;

export const focusVisibleStyles = `
  &:focus-visible {
    ${focusVisibleStylesNoWrapper}
  }
`;

// custom inset box shadow for cases where the container needs to have overflow: hidden
export const focusVisibleInsetStylesNoWrapper = `
    box-shadow:
      inset 0px 0px 0px 2px var(--purple-700);
    ${transparentOutline}
`;

export const focusVisibleInsetStyles = `
  &:focus-visible {
    ${focusVisibleInsetStylesNoWrapper}
  }
`;

export const standardTransitionStyles = `
  transition:
    color 0.2s ease-out,
    background-color 0.2s ease-out,
    border-color 0.2s ease-out,
    box-shadow 0.2s ease-out,
    min-height 0.2s ease-out,
    width 0.2s ease-out,
    opacity 0.2s ease-out,
    max-height 0.2s ease-out,
    transform 0.2s ease-out;
`;

export const dropdownTriggerStyles = `
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
  padding: 0 12px;
  height: 32px;
  border-radius: var(--border-radius-medium);
  border: 1px solid var(--grayscale-100);
  background-color: transparent;
  cursor: pointer;
  color: var(--grayscale-900);
  white-space: nowrap;
  width: fit-content;
  ${standardTransitionStyles}

  &:hover {
    background-color: var(--grayscale-50);
    border-color: var(--grayscale-50);
  }

  ${focusVisibleStyles}
`;

export const popoverBoxshadow = `
  box-shadow: 0px 2px 8px 0px rgba(0, 0, 0, 0.1);
`;

export const containerBoxShadow = `
  box-shadow: 0 0 6px 0 rgba(0, 0, 0, 0.1);
`;
